import ProductThumb from './ProductThumb.vue'

export { PRODUCT_DISPLAYS } from './ProductThumb.vue'
export { buildResultsFromAttributes, isLinkValid } from './helpers'

export default ProductThumb
